<div class='request-table__container'>
  <button mat-flat-button (click)='openAddRequest()' class='request-table__add-button'>{{ buttonLabel | translate }}
  </button>
</div>
<div class='request-table__scroll'>
  <table mat-table [dataSource]="requests" class="request-table__table">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>{{ tableLabel | translate }}</th>
      @if (type == RequestType.SKILL) {
        <td mat-cell *matCellDef="let element"> {{ element?.faehigkeit }} {{ element?.kategorie }}</td>
      } @else {
      <td mat-cell *matCellDef="let element"> {{ element?.name }}</td>
    }
    </ng-container>
    <ng-container matColumnDef="nameDe">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'request.table.inLanguage' | translate: {label: (nameColumnLabel | translate), language: ('languages.de' | translate)} }}
      </th>
      <td mat-cell *matCellDef="let element" class="request-table__name">
        <ng-container *ngTemplateOutlet="nameCell; context: {element, language: 'de'}"></ng-container>
      </td>
    </ng-container>
    <ng-container matColumnDef="nameEn">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'request.table.inLanguage' | translate: {label: (nameColumnLabel | translate), language: ('languages.en' | translate)} }}
      </th>
      <td mat-cell *matCellDef="let element" class="request-table__name">
        <ng-container *ngTemplateOutlet="nameCell; context: {element, language: 'en'}"></ng-container>
      </td>
    </ng-container>
    <ng-container matColumnDef="requestedBy">
      <th mat-header-cell *matHeaderCellDef>{{ 'request.table.requestedBy' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        {{ element?.requestedByUser?.firstName }} {{ element?.requestedByUser?.lastName }}

        @if (element?.requestedByUser?.email) {
          <span>
        ({{ element.requestedByUser.email }})
      </span>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>{{ "request.table.manage" | translate }}</th>
      <td mat-cell *matCellDef="let element">
        <div class='request-table__buttons'>
          <button mat-flat-button (click)='openAcceptRequest(element)'
                  class='request-table__accept'>
            <mat-icon class="request-table__button-icon">check</mat-icon>
            <span class="request-table__button-label">
                      {{ 'request.table.accept' | translate }}
                  </span>
          </button>
          <button mat-flat-button (click)='openDeleteModal(element)'
                  class='request-table__decline'>
            <mat-icon class="request-table__button-icon">delete</mat-icon>
            <span class="request-table__button-label">
                        {{ 'request.table.decline' | translate }}
                  </span>
          </button>
          @if (!bilingual) {
            <button mat-icon-button (click)='editRequest(element)'>
              <mat-icon>edit</mat-icon>
            </button>
          }
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
<mat-paginator [length]="totalRequests"
               class='request-table__pagination'
               [pageSize]="pageSize"
               [pageSizeOptions]="[5, 10, 25, 100]"
               [showFirstLastButtons]="true"
               (page)="onPageChange($event)"
               [attr.aria-label]="'request.table.pagination' | translate">
</mat-paginator>

<app-modal
  modalId="deleteRequest"
  [title]="modalDeleteHeader"
  [text]="modalDeleteLabel"
  [(visible)]="showDeleteModal"
  [showButtons]="true"
  (save)="deleteRequest(currentElement)"
  [showClose]="true"
  [saveText]="'general.delete'"
  [contentTemplate]='deleteRequestTemplate'
></app-modal>

<ng-template #nameCell let-element="element" let-language="language">
  @for (part of nameParts(element, language); track $index) {
    @if (!$first) {
      <span aria-hidden="true"> – </span>
    }
    @if (part?.trim()) {
      {{ part }}
    } @else {
      <span class="request-table__missing">{{ 'request.table.missing' | translate }}</span>
    }
  }
</ng-template>

<ng-template #deleteRequestTemplate>
  @if (bilingual) {
    <ng-container *ngTemplateOutlet="bilingualNamesTemplate"></ng-container>
  } @else {
    <p>{{ currentElement?.faehigkeit }} {{ currentElement?.name }} {{ currentElement?.kategorie }}</p>
  }
</ng-template>

<ng-template #bilingualNamesTemplate>
  <dl class="request-table__names">
    @for (language of languages; track language) {
      <dt>{{ 'languages.' + language | translate }}</dt>
      <dd>{{ displayName(currentElement, language) || ('request.table.missing' | translate) }}</dd>
    }
  </dl>
</ng-template>

@if (!bilingual) {
<app-modal
  modalId="editRequest"
  [title]="modalEditHeader"
  [(visible)]="showEditModal"
  [showButtons]="true"
  (save)="saveEditRequest(currentElement)"
  [showClose]="true"
  [disabled]="editRequestFormInvalid || !hasChanges()"
  [saveText]="'general.save'"
  [contentTemplate]="addRequestTemplate"
></app-modal>
}

<ng-template #acceptBilingualTemplate>
  <form>
    @if (type === RequestType.SKILL) {
      <div class="request-table__category">
        <app-ci-select
          name="category"
          [ngModel]="currentCategory"
          (ngModelChange)="onAcceptCategoryChange($event?.kategorie ?? '')"
          [required]="true"
          [items]="acceptCategoryOptions"
          [displayWith]="categoryLabel"
          [isDisabled]="isCategoryDisabled"
          [label]="'request.modals.category' | translate"
          [ariaLabel]="'request.modals.category' | translate"
          [placeholder]="'skillCategorySelect.placeholder' | translate"
          [searchPlaceholder]="'skillCategorySelect.search' | translate"
          [searchClearLabel]="'ciSelect.clearSearch' | translate"
          [emptyLabel]="'skillCategorySelect.empty' | translate"
          [hitTemplate]="'ciSelect.hits' | translate"
        ></app-ci-select>
        @if (acceptCategoryWithoutEnglish) {
          <p class="request-table__category-hint">{{
            'request.modals.categoryWithoutEnglish'
              | translate: { category: currentElement.kategorie }
          }}</p>
        } @else if (currentElement?.kategorie && categories.length && !acceptCategory) {
          <p class="request-table__category-hint">{{ 'request.modals.categoryNotInList' | translate: {category: currentElement.kategorie} }}</p>
        }
      </div>
    }
    @for (field of acceptFields; track field.key) {
      <mat-form-field class="request-table__form-field">
        <mat-label>{{ field.label | translate: {language: ('languages.' + field.language | translate)} }}</mat-label>
        <input
          matInput
          [name]="field.key"
          [ngModel]="currentElement[field.key]"
          (ngModelChange)="currentElement[field.key] = $event; onAcceptFormChange()"
          [maxlength]="LIMITS.SHORT_LABEL"
          required
        />
        <mat-hint align="end">{{ (currentElement[field.key]?.length || 0) }}/{{ LIMITS.SHORT_LABEL }}</mat-hint>
        <mat-error>{{ 'request.modals.nameRequired' | translate }}</mat-error>
      </mat-form-field>
    }
    @if (acceptHasForbiddenCharacters) {
      <p class="request-table__hint" role="alert">{{ 'request.modals.controlCharacters' | translate }}</p>
    }
  </form>
</ng-template>

@if (bilingual) {
  <app-request-dialog
    [type]="type"
    [modalId]="'addRequest' + type"
    [title]="buttonLabel"
    [(visible)]="showAddModal"
    [showInfo]="false"
    [allowExisting]="false"
    [saveText]="'general.save'"
    (requested)="loadAllRequests()"
  ></app-request-dialog>
} @else {
<app-modal
  modalId="addRequest"
  [title]="buttonLabel"
  [(visible)]="showAddModal"
  [showButtons]="true"
  (save)="saveAddRequest(currentElement)"
  [showClose]="true"
  [disabled]="addRequestFormInvalid"
  [saveText]="'general.save'"
  [contentTemplate]='addRequestTemplate'
></app-modal>
}

<ng-template #addRequestTemplate>
  <form>
    <mat-form-field class="request-table__form-field">
      <mat-label>
        {{ 'request.modals.name'| translate }}
      </mat-label>
      <input
        matInput
        name="requests"
        [(ngModel)]="currentElement.name"
        (ngModelChange)="onAddRequestFormChange()"
        #requestsField="ngModel"
        required
      />
      @if (requestsField.invalid && requestsField.touched) {
        <mat-error>
          {{
            'general.errors.required' | translate
          }}
        </mat-error>
      }
    </mat-form-field>
  </form>
</ng-template>

@if (bilingual) {
<app-modal
  modalId="acceptRequest"
  [title]="modalAcceptHeader"
  [text]="'request.modals.acceptIntro'"
  [(visible)]="showAcceptModal"
  [showButtons]="true"
  (save)="saveAndAccept()"
  [showClose]="true"
  [disabled]="acceptFormInvalid"
  [saveText]="'request.table.saveAndAccept'"
  [contentTemplate]="acceptBilingualTemplate"
></app-modal>
} @else {
<app-modal
  modalId="acceptRequest"
  [title]="modalAcceptHeader"
  [text]="modalAcceptLabel"
  [(visible)]="showAcceptModal"
  [showButtons]="true"
  (save)="acceptRequest(currentElement)"
  [showClose]="true"
  [saveText]="'request.table.accept'"
  [contentTemplate]='acceptRequestTemplate'
></app-modal>
}

<ng-template #acceptRequestTemplate>
  <p>{{ currentElement?.name }} {{ currentElement?.faehigkeit }} {{ currentElement?.kategorie }}</p>
</ng-template>
